
import {
  FETCH_CATEGORY_REQUEST,
  FETCH_CATEGORY_SUCCESS,
  FETCH_CATEGORY_FAILURE,
  CREATE_CATEGORY_REQUEST,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILURE,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
} from "./categoryActionTypes";

const initialState = {
  loading: false,
  categoryData: [],
  error: null,
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH
    case FETCH_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        categoryData: action.payload.data,
      };
    case FETCH_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        categoryData: [],
      };

    // CREATE
    case CREATE_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        categoryData: action.payload.data,
      };
    case CREATE_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // UPDATE
    case UPDATE_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        categoryData: action.payload.data,
      };
    case UPDATE_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // DELETE
    case DELETE_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        categoryData: action.payload.data,
      };
    case DELETE_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default categoryReducer;
  